import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Up to two letters for a name with no picture: the first letters of the
 *  first two words, or the first two letters of a single word. "" when blank. */
export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "";
  if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
  return (words[0]![0]! + words[1]![0]!).toUpperCase();
}

/** The word for `n` of something: `singular` for exactly one, else its plural
 *  (`singular` + "s" unless given). */
export function plural(n: number, singular: string, many = `${singular}s`): string {
  return n === 1 ? singular : many;
}
